import { FastField, Formik } from 'formik';
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import ClosePopup from 'Assets/images/close-popup.svg';
import {
  Button,
  Form,
  Grid,
  Modal,
} from 'semantic-ui-react';
import {
  InputField,
  DropdownField,
  SingleDatePickerField,
  PhoneInput,
} from 'Modules/Formik';
import css from './AddUser.less';
import { schemaValidation } from './Validation';

const initialValues = {
  firstName: '',
  lastName: '',
};

const AddUser = ({ data, id }) => {
  const ref = useRef(null);

  const dispatch = useDispatch();

  const onClose = () => {
    dispatch(removeModal(id));
  };

  const onSubmit = async (values) => {
  };

  return (
    <div className={css.container}>
      <Modal
        onClose={onClose}
        open
        closeIcon={<img className={css.closeIcon} src={ClosePopup} alt="close popup" />}
        className={css.customModal}
        size="medium"
      >
        <Modal.Header>Add User</Modal.Header>
        <Modal.Content className={css.modalContent}>
          <Formik
            initialValues={initialValues}
            validationSchema={schemaValidation}
            validateOnChange
            innerRef={ref}
            onSubmit={onSubmit}
          >
            {({ values, errors, touched }) => (
              <Form>
                <Grid>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="firstName"
                        component={InputField}
                        placeholder="First Name"
                        label="First Name"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="lastName"
                        component={InputField}
                        placeholder="Last Name"
                        label="Last Name"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="title"
                        component={DropdownField}
                        placeholder="Title"
                        label="Title"
                        options={[]}
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="gender"
                        component={DropdownField}
                        placeholder="Gender"
                        label="Gender"
                        options={[]}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="dob"
                        component={SingleDatePickerField}
                        placeholder="Date of Birth"
                        label="Date of Birth"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="phone"
                        component={PhoneInput}
                        placeholder="Phone"
                        label="Phone"
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row columns={2}>
                    <Grid.Column>
                      <FastField
                        name="email"
                        component={InputField}
                        placeholder="Email"
                        label="Email"
                      />
                    </Grid.Column>
                    <Grid.Column>
                      <FastField
                        name="Roles"
                        component={DropdownField}
                        placeholder="Roles"
                        label="Roles"
                      />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Form>
            )}
          </Formik>
        </Modal.Content>
        <Modal.Actions>
          <Button
            onClick={() => {
              onClose();
            }}
          >
            Close
          </Button>
          <Button
            onClick={() => {
              ref?.current?.handleSubmit();
            }}
            primary
            className={css.submitBtn}
          >
            Add
          </Button>
        </Modal.Actions>
      </Modal>
    </div>
  );
};

export default AddUser;
